<template>
  <div class="form-block">
    <el-form
      ref="form"
      :model="searchForm"
      :label-width="labelWidth"
      :inline="true"
      label-position="left"
    >
      <el-form-item v-for="(item, index) in searchFormTemp" :key="index" :label="item.lable" :style="item.marginLeft?'margin-left:'+item.marginLeft:''">
        <el-input
          v-if="item.type == 'input'"
          v-model="searchForm.param[item.name]"
          :placeholder="item.placeholder || '请输入'"
           clearable
        ></el-input>
        <el-select
          v-if="item.type == 'select'"
          v-model="searchForm.param[item.name]"
          filterable
          :placeholder="item.placeholder || '请选择'"
          clearable
        >
          <el-option
            v-for="(el, idx) in item.list || dicMap[item.dic]"
            :key="idx"
            :label="el.dicItemName"
            :value="el.dicItemCode"
          ></el-option>
        </el-select>
        <el-date-picker
          v-if="item.type == 'datePicker'"
          v-model="searchForm.param[item.name]"
          :format="item.itemType&&item.itemType=='year'?'yyyy': 'yyyy-MM-dd'"
          :value-format="item.itemType&&item.itemType=='year'?'yyyy': 'yyyy-MM-dd'"
          clearable
          :type="item.itemType || 'date'"
          :placeholder="item.placeholder || '请选择'"
           :picker-options="dateOptions(item)"
        ></el-date-picker>
        <doubleDate
          v-if="item.type === 'doubleDate'"
          :elType="item.elType"
          :options="item.options"
          :name="item.name ? item.name : ''"
          @editParams="getDateTime"
        ></doubleDate>
      </el-form-item>
       <slot name="customer"></slot>
      <el-form-item>
        <el-button type="primary" @click="normalSearch()">搜索</el-button>
        <el-button
          @click="normalResetQuery()"
          type="primary"
          plain

        >重置</el-button>
      </el-form-item>
       <slot name="exportBtn"></slot>
    </el-form>
  </div>
</template>

<script>
import { getDic, fetchDics } from "@/utils/dictionary";
import doubleDate from "@/components/doubleDate";
import { stringify } from 'qs';
export default {
  name: "",
  props: {
    searchForm: {
      type: Object,
      default: function() {
        return {};
      }
    },
    searchFormTemp: {
      type: Array,
      default: function() {
        return [];
      }
    },
    labelWidth:{
      type:String,
      default:'auto'
    }
  },
  data() {
    return {};
  },
  components: {
    doubleDate
  },
  computed: {
    dicMap(){
      return this.$store.state.dicMap
    },
        startTime() {
      return (
        this.searchForm.param.startTime || this.searchForm.param.createTimeS || this.searchForm.param.effectiveTime
      );
    },
    endTime() {
      return this.searchForm.param.endTime || this.searchForm.param.createTimeE || this.searchForm.param.validityTime;
    },
    dateOptions() {
      return item => {
        if (item.option) return item.option;
        if (item.name === 'startTime' || item.name === 'createTimeS') {
          return {
            disabledDate: time => {
              if (this.endTime) {
                return time.getTime() > Date.now() || time.getTime() > new Date(this.endTime).getTime();
              } else {
                return time.getTime() > Date.now();
              }
            },
          };
        } else if (item.name === 'endTime' || item.name === 'createTimeE') {
          return {
            disabledDate: time => {
              if (this.startTime) {
                return (
                  time.getTime() > Date.now() ||
                  time.getTime() <= new Date(this.startTime).getTime() - 24 * 60 * 60 * 1000
                );
              } else {
                return time.getTime() > Date.now();
              }
            },
          };
        }
      };
    },
  },
  created() {
    // this.initData();
  },
  mounted() {
    this.$nextTick(() => {
      let el = document.querySelector(".el-form-item__label-wrap");
      if (el) {
        el.style.marginLeft = 0;
      }
    });
  },
  methods: {
    async initData() {
      if (this.searchFormTemp.length == 0) {
        return;
      }
      // 字典转化 异步函数要用for
      for (let i = 0; i < this.searchFormTemp.length; i++) {
        let item = this.searchFormTemp[i];
        if (item.dictionary && item.dictionary.length) {
          await fetchDics(item.dictionary);
          item.list = await getDic(item.dictionary[0].id);
        }
      }
    },
    normalSearch() {
      this.handleSearchForm();
      this.$emit("normalSearch", this.searchForm);
    },
    normalResetQuery() {
      this.$refs.form.resetFields();
      this.$emit("normalResetQuery");
    },
    getDateTime(arr, name) {
      this.searchFormTemp.forEach(item => {
        if (item.type == "doubleDate") {
          if (item.name == name) {
            item.options[0].value = arr[0];
            item.options[1].value = arr[1];
          }
        }
      });
    },
    handleSearchForm() {
      let tempObj = {};
      for (let item of this.searchFormTemp) {
        if (item.type == "doubleDate") {
          for (let li of item.options) {
            tempObj[li.name] = li.value;
          }
        }
      }
      this.searchForm.param = Object.assign({}, this.searchForm.param, tempObj);
    }
  }
};
</script>

<style lang="less" scoped>
//固定输入框度
.form-block {
  background: #fff;
  // padding-top: 20px;
  padding-left: 40px;
  .el-input--medium {
    width: 215px !important;
  }
  .el-input__inner,
  .el-button--medium {
    border-radius: 6px;
  }
  .el-form-item__label {
    color: #333;
  }
}
/deep/.el-button--primary.is-plain:hover {
  color: #e27c00;
}
/deep/.el-button--primary.is-plain:active {
  color: #e27c00;
}
/deep/.el-button--primary.is-plain:focus {
  color: #e27c00;
}
</style>
